<template>
  <div>
    <div
      v-if="
        Object.keys(streamingStreamGroup).length ||
        scheduledStreamGroups.length ||
        notStreamingStreamGroups.length
      "
    >
      <div v-if="Object.keys(streamingStreamGroup).length" class="streaming-stream-group">
        <div class="streaming-stream-group-header">配信中</div>
        <div class="stream-group-list">
          <JaStreamGroupRow
            :isAxiosWait="isAxiosWait"
            :setIsAxiosWait="setIsAxiosWait"
            :streamGroup="streamingStreamGroup"
            :isStreaming="true"
            :getStreamGroup="getStreamGroup"
            :moveStreamGroupDetail="moveStreamGroupDetail"
          />
        </div>
      </div>
      <div
        v-if="scheduledStreamGroups.length"
        class="streaming-stream-group scheduled-streaming-stream-group"
      >
        <div class="streaming-stream-group-header d-flex justify-between">配信予約中</div>
        <div class="stream-group-list">
          <JaStreamGroupScheduledRow
            v-for="streamGroup in scheduledStreamGroups"
            :key="streamGroup.streamingScheduleId"
            :isAxiosWait="isAxiosWait"
            :setIsAxiosWait="setIsAxiosWait"
            :streamGroup="streamGroup"
            :isStreaming="false"
            :getStreamGroup="getStreamGroup"
            :openModal="openModal"
            :moveStreamGroupDetail="moveStreamGroupDetail"
          />
        </div>
      </div>
      <div v-if="notStreamingStreamGroups.length" class="not-streaming-stream-group">
        <div class="not-streaming-stream-group-header">未配信</div>
        <div class="stream-group-list">
          <template
            v-for="streamGroup in notStreamingStreamGroups"
            :key="streamGroup.streamGroupId"
          >
            <JaStreamGroupUploadingRow
              v-if="isStreamGroupUploading(streamGroup.streamGroupUploadStatus)"
              :streamGroup="streamGroup"
              :moveStreamGroupDetail="moveStreamGroupDetail"
            />
            <JaStreamGroupRow
              v-else
              :isAxiosWait="isAxiosWait"
              :setIsAxiosWait="setIsAxiosWait"
              :streamGroup="streamGroup"
              :isStreaming="false"
              :getStreamGroup="getStreamGroup"
              :openModal="openModal"
              :moveStreamGroupDetail="moveStreamGroupDetail"
            />
          </template>
        </div>
      </div>
    </div>
    <EmptyContent :emptyPageNum="EMPTY_PAGE_NUM.STREAM_GROUP" v-else />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import JaStreamGroupUploadingRow from '@/components/JaStreamGroup/JaStreamGroupUploadingRow.vue';
import JaStreamGroupRow from '@/components/JaStreamGroup/JaStreamGroupRow.vue';
import EmptyContent from '@/components/common/EmptyContent.vue';
import JaStreamGroupScheduledRow from '@/components/JaStreamGroup/JaStreamGroupScheduledRow.vue';
import { EMPTY_PAGE_NUM, STREAM_GROUP_UPLOAD_STATUS } from '@/composable/constant_common';

defineProps({
  streamingStreamGroup: Object,
  notStreamingStreamGroups: Array,
  scheduledStreamGroups: Array,
  getStreamGroup: Function,
  openModal: Function,
});

// axios通信処理待機フラグ
const isAxiosWait = ref(false);

const router = useRouter();
const store = useStore();

/**
 * isAxiosWait更新処理
 */
const setIsAxiosWait = (value) => {
  isAxiosWait.value = value;
};

/**
 * 配信グループ詳細画面遷移処理
 */
const moveStreamGroupDetail = (streamGroupId) => {
  if (!streamGroupId) return;

  // Vue-routerのparamsで配信グループIDを渡すと、当該画面→配信グループ詳細画面は問題ないが、
  // コンテンツ詳細→配信グループ詳細画面の際に配信グループIDがundefinedとなりエラーが生じるため、streamGrouoStoreに配信グループIDを格納
  store.commit('streamGroup/setIsStreamGroupUpdate', false);
  store.commit('streamGroup/setStreamGroupId', streamGroupId);
  store.commit('streamGroup/setStreamGroupName', '');
  store.commit('streamGroup/setStreamGroupContentList');
  router.push('/ja/streamGroup/streamGroupDetail');
};

/**
 * DB登録済かつアップロード中の配信グループ判定処理
 *
 * @param streamGroupUploadStatus 配信グループ登録状態ステータス
 */
const isStreamGroupUploading = (streamGroupUploadStatus) => {
  return [
    STREAM_GROUP_UPLOAD_STATUS.STREAM_GROUP_UPLOAD_ERR,
    STREAM_GROUP_UPLOAD_STATUS.STREAM_GROUP_UPLOADING,
  ].includes(streamGroupUploadStatus);
};
</script>

<style scoped>
/** 配信グループリストヘッダ */
.streaming-stream-group-header,
.not-streaming-stream-group-header {
  padding: 1rem 2rem;
  font-size: 1.4rem;
  font-weight: bold;
}
.streaming-stream-group-header {
  display: flex;
  justify-content: space-between;
  align-items: end;
  color: #20963b;
}
.not-streaming-stream-group-header {
  margin-top: 1rem;
  color: #222222;
}

/** 配信グループリロードボタン */
.reload-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  border: none;
  background-color: inherit;
  color: #444;
  opacity: 0.4;
}
</style>
